<section
  class="uploaded-table-container"
  [class.local-mode]="mode === 'local'"
  cdkDropList
  [id]="dragDropListId"
  [cdkDropListData]="documents"
  [cdkDropListSortingDisabled]="true"
  [cdkDropListDisabled]="readOnly()"
  [cdkDropListConnectedTo]="dragDropConnections"
>
  @if (documents.length) {
    <div class="table-scroll">
      <table mat-table data-tour="linking_dialog_tb" [dataSource]="documents" class="documents-table mat-elevation-z1 uploaded-table">
        <ng-container matColumnDef="preview">
          <th mat-header-cell *matHeaderCellDef>
            <div class="preview-header-desktop">
              @if (mode === 'uploaded') {
                <button class="sort-header" type="button" (click)="handleSort('status')">
                  {{ statusLabel }}
                  <mat-icon>{{ sortIcon('status') }}</mat-icon>
                </button>
              } @else {
                <span>{{ 'Preview_tr' | translate }}</span>
              }
            </div>
            <div class="preview-header-mobile">
              <button class="sort-header" type="button" (click)="handleSort('title')">
                {{ titleLabel }}
                <mat-icon>{{ sortIcon('title') }}</mat-icon>
              </button>
              /
              <button class="sort-header" type="button" (click)="handleSort('type')">
                {{ typeLabel }}
                <mat-icon>{{ sortIcon('type') }}</mat-icon>
              </button>
            </div>
          </th>
          <td mat-cell *matCellDef="let document">
            <div class="preview-wrapper">
              <div class="preview-thumb-wrapper" [class.preview-hover-enabled]="previewHoverEnabled">
                @if (previewSrc(document); as src) {
                  <img class="preview-thumb" [alt]="document.title" [attr.src]="src" />
                } @else if (hasPreviewError(document)) {
                  <div class="document-preview-error">
                    <mat-icon color="warn">error</mat-icon>
                    <span>{{ 'document_preview_error_tr' | translate }}</span>
                    <a [attr.href]="supportMailto(document)" target="_blank" rel="noopener noreferrer">
                      <mat-icon>support_agent</mat-icon>
                      {{ 'Contact_Support_tr' | translate }}
                    </a>
                  </div>
                } @else {
                  <mat-icon>{{ fallbackIcon(document) }}</mat-icon>
                }
                @if (previewHoverEnabled && previewSrc(document) && !hasPreviewError(document)) {
                  <button type="button" class="preview-hover-button" (click)="handlePreviewView(document, $event)">
                    <mat-icon>visibility</mat-icon>
                    <span>{{ 'Preview_tr' | translate }}</span>
                  </button>
                }
              </div>
              @if (mode === 'uploaded' && document.status) {
                <span class="status-badge" [ngClass]="'status-' + document.status.toLowerCase()">
                  {{ document.status | titlecase }}
                </span>
              }
              <div class="mobile-title-block">
                <div class="doc-title">{{ document.title }}</div>
                <div class="doc-type">{{ documentTypeName(document) }}</div>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="details">
          <th mat-header-cell *matHeaderCellDef class="details-cell">
            <div class="details-header">
              <div class="sort-group">
                <button class="sort-header" type="button" (click)="handleSort('title')">
                  {{ titleLabel }}
                  <mat-icon>{{ sortIcon('title') }}</mat-icon>
                </button>
                /
                <button class="sort-header" type="button" (click)="handleSort('type')">
                  {{ typeLabel }}
                  <mat-icon>{{ sortIcon('type') }}</mat-icon>
                </button>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let document" class="details-cell">
            <div class="doc-title">
              {{ document.title }}
            </div>
            <div class="doc-type">{{ documentTypeName(document) }}</div>
            @if (documentUsages(document); as usages) {
              @if (usages.length && usagePresentation === 'chips') {
                <div class="usage-chips">
                  @for (usage of usages; track usage.link + usage.type) {
                    <span class="usage-chip" [matTooltip]="usageLabel(usage)" (click)="handleUsageClick(usage, $event)">
                      <mat-icon>{{ usageIcon(usage) }}</mat-icon>
                      <span class="usage-chip-label">{{ usageLabel(usage) }}</span>
                    </span>
                  }
                </div>
              } @else if (usages.length && usagePresentation === 'count') {
                @if (!isUsageExpanded(document)) {
                  <button type="button" class="usage-count-link" (click)="toggleUsageList(document, $event)">
                    <span>{{ 'show_tr' | translate }} {{ usageCount(document) }} {{ usageCountLabel(document) }}</span>
                  </button>
                }
                @if (isUsageExpanded(document)) {
                  <div class="usage-count-list">
                    @for (usage of usages; track usage.link + usage.type) {
                      <button type="button" class="usage-count-list__row" (click)="handleUsageClick(usage, $event)">
                        <mat-icon>{{ usageIcon(usage) }}</mat-icon>
                        <span class="usage-count-list__label">{{ usageLabel(usage) }}</span>
                        <mat-icon class="usage-count-list__new-tab">open_in_new</mat-icon>
                      </button>
                    }
                  </div>
                }
              }
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th class="date-cell" mat-header-cell *matHeaderCellDef>
            <button class="sort-header" type="button" (click)="handleSort('date')">
              {{ dateLabel }}
              <mat-icon>{{ sortIcon('date') }}</mat-icon>
            </button>
          </th>
          <td mat-cell *matCellDef="let document" class="date-cell">{{ documentDate(document) | date }}</td>
        </ng-container>

        @if (mode === 'local') {
          <ng-container matColumnDef="size">
            <th mat-header-cell *matHeaderCellDef>
              <button class="sort-header" type="button" (click)="handleSort('size')">
                {{ sizeLabel }}
                <mat-icon>{{ sortIcon('size') }}</mat-icon>
              </button>
            </th>
            <td data-column="size" mat-cell *matCellDef="let document">
              {{ documentSize(document) !== undefined ? sizeFormatter(documentSize(document) ?? 0) : '—' }}
            </td>
          </ng-container>
        }

        @if (!hideActions) {
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>{{ 'Actions_tr' | translate }}</th>
            <td mat-cell *matCellDef="let document">
              <div class="actions">
                @if (mode === 'local' && isLocalDocument(document) && document.kind !== 'zip') {
                  <button
                    type="button"
                    mat-stroked-button
                    class="action-btn"
                    [matTooltip]="rowTooltip ? rowTooltip(document) : ('Upload_to_server_tr' | translate)"
                    [disabled]="disableActions"
                    (click)="handleUpload(document, $event)"
                  >
                    <mat-icon>{{ disableActions ? 'cloud_sync' : 'upload' }}</mat-icon>
                  </button>
                  <button
                    type="button"
                    mat-stroked-button
                    class="action-btn"
                    data-testid="delete-document-btn"
                    matTooltip="{{ 'Delete_tr' | translate }}"
                    [disabled]="disableActions"
                    (click)="handleDelete(document, $event)"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                } @else if (mode === 'local' && isLocalDocument(document) && document.kind === 'zip') {
                  <button
                    type="button"
                    mat-stroked-button
                    class="action-btn"
                    data-testid="delete-document-btn"
                    matTooltip="{{ 'Delete_tr' | translate }}"
                    [disabled]="disableActions"
                    (click)="handleDelete(document, $event)"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                } @else {
                  <button
                    type="button"
                    mat-stroked-button
                    class="action-btn"
                    [class.document-in-use]="hasUsages(document)"
                    [matTooltip]="hasUsages(document) ? ('Document_in_use_tr' | translate) : ('Edit_tr' | translate)"
                    [disabled]="readOnly() || hasUsages(document)"
                    (click)="handleEdit(document, $event)"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button
                    type="button"
                    mat-stroked-button
                    class="action-btn"
                    data-testid="delete-document-btn"
                    [class.document-in-use]="hasUsages(document)"
                    [matTooltip]="hasUsages(document) ? ('Document_in_use_tr' | translate) : ('Delete_tr' | translate)"
                    [disabled]="readOnly() || hasUsages(document)"
                    (click)="handleDelete(document, $event)"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                }
              </div>
            </td>
          </ng-container>
        }

        @let headerColumns =
          mode === 'local'
            ? hideActions
              ? ['preview', 'details', 'date', 'size']
              : ['preview', 'details', 'date', 'size', 'actions']
            : hideActions
              ? ['preview', 'details', 'date']
              : ['preview', 'details', 'date', 'actions'];
        <tr mat-header-row *matHeaderRowDef="headerColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: headerColumns"
          class="document-row"
          [class.selected-row]="isSelected(row)"
          [class.highlight]="isHighlighted(row)"
          cdkDrag
          [cdkDragDisabled]="readOnly() || !dragEnabled"
          [cdkDragData]="row"
          cdkDragPreviewClass="document-drag-preview"
          [matTooltip]="rowTooltip ? rowTooltip(row) || null : null"
          (cdkDragMoved)="handleDragMoved(row, $event)"
          (click)="handleRowClick(row)"
        >
          <ng-template cdkDragPreview [matchSize]="true">
            <div class="source-document-drag-preview source-document-drag-preview--row">
              <div class="source-document-drag-preview__thumbnail">
                @if (previewSrc(row); as preview) {
                  <img [src]="preview" [alt]="row.title" />
                } @else {
                  <mat-icon>{{ row.fileType?.includes('pdf') ? 'picture_as_pdf' : 'description' }}</mat-icon>
                }
              </div>
              <div class="source-document-drag-preview__details">
                <strong>{{ row.title }}</strong>
                <span>{{ documentTypeName(row) }}</span>
                @if (documentUsages(row); as usages) {
                  @if (usages.length) {
                    <span class="source-document-drag-preview__usage">
                      {{ 'show_tr' | translate }} {{ usages.length }} {{ usageCountLabel(row) }}
                    </span>
                  }
                }
              </div>
              <time>{{ documentDate(row) | date }}</time>
            </div>
          </ng-template>
        </tr>
      </table>
    </div>
    <mat-paginator
      [length]="total"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [showFirstLastButtons]="true"
      [hidePageSize]="true"
      (page)="handlePage($event)"
    ></mat-paginator>
  } @else {
    <div class="empty-state" [attr.data-testid]="emptyStateTestId ?? null">
      <mat-icon>inventory_2</mat-icon>
      <p>{{ emptyTitle }}</p>
      <small>{{ emptySubtitle }}</small>
    </div>
  }
</section>
